export default "/strSHELL.a29081b26b73678a17b6bddd09e66dcb.png";